import { z } from "zod";

function booleanFlag(defaultValue: boolean) {
  return z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((value) => {
      if (value === undefined) return defaultValue;
      if (typeof value === "boolean") return value;
      return value === "true" || value === "1";
    });
}

const envSchema = z.object({
  baseUrl: z.string().default("http://localhost:4174"),
  cloudflareAnalyticsToken: z.string().optional(),
  enableAnalytics: booleanFlag(false),
  mode: z.string(),
  plausibleDomain: z.string().optional(),
});

export type AppEnv = z.infer<typeof envSchema>;

function coalesce(value: unknown): unknown {
  if (value === "" || value === undefined) return undefined;
  return value;
}

export function readAppEnv(envSource: ImportMetaEnv = import.meta.env): AppEnv {
  const typedEnv = envSource as Record<string, string | undefined>;

  return envSchema.parse({
    baseUrl: typedEnv.VITE_PUBLIC_BASE_URL,
    cloudflareAnalyticsToken: coalesce(
      typedEnv.VITE_CLOUDFLARE_ANALYTICS_TOKEN,
    ),
    enableAnalytics: typedEnv.VITE_ENABLE_ANALYTICS,
    mode: typedEnv.MODE,
    plausibleDomain: coalesce(typedEnv.VITE_PLAUSIBLE_DOMAIN),
  });
}
